import React, { ReactNode } from 'react';
import { GridCol, GridRow } from '@naf/grid';
import { Text, TextVariant } from '@naf/text';
import { EmptyMessagesWrapper } from '../ArticleGrid.styles';

interface Props {
  title: string;
  children: ReactNode;
  /** Only the empty state illustrates itself; the error state is text alone. */
  illustration?: ReactNode;
}

/** The full-width notice the grid shows in place of cards, for both the error and empty states. */
export const ArticleGridMessage = ({ title, children, illustration }: Props) => (
  <GridRow>
    <GridCol s="12" m="12" l="12" xl="12">
      <EmptyMessagesWrapper>
        {illustration}
        <Text variant={TextVariant.Header3} tag="h2">
          {title}
        </Text>
        <Text variant={TextVariant.ArticleText}>{children}</Text>
      </EmptyMessagesWrapper>
    </GridCol>
  </GridRow>
);
